function _decorate$reduce(fn, decorator) {
  return decorator(fn) || fn;
}
export default function decorate(decorators, fn) {
  return decorators.reverse().reduce(_decorate$reduce, fn);
}



// WEBPACK FOOTER //
// ./spa/lib/decorate.jsx